// 按页面划分
export default {
    // 公共页面
    common: {
        title:"Data Mall",
        pull_refresh: 'Tarik ke bawah untuk menyegarkan',
        release_refresh: 'Pelepasan untuk menyegarkan',
        refresh_loading: 'Memuatkan…',
        footer_text: 'Perkhidmatan disediakan oleh Ucloudlink (NASDAQ: UCL)'
      },
      home: {
        input_placeholder: 'Cari Negara/Wilayah',
        my_flow: 'Data saya',
        charge_code: 'Kod baucar',
        coupons:'Kupon',
        local_package: 'Data tempatan',
        more: 'Lebih',
        popular_destination: 'Negara/wilayah',
        buy_now: 'Beli sekarang',
        package_useing: 'Aktif',
        unused: 'Tidak aktif',
        download_app: 'Muat turun APP',
        enter_the_mall_list: 'Masuk ke senarai pusat membeli-belah',
        no_data: 'Tiada data',
        no_data_available: 'Tiada data tersedia',
        copy_success: 'Salin berjaya',
        copy_fail: 'Salin gagal',
        meritsTitle: 'Apakah Kelebihannya?',
        merits1: 'Tanpa SIM & Tanpa Yuran Bulanan',
        merits2: 'Diintegrasikan dengan 2-3 operator teratas untuk penukaran rangkaian automatik',
        go_buy: 'Pergi untuk membeli',
        instant_savings: 'Jimat',
        expires_in: 'Luput dalam',
        download_app_tips: "Muat turun apl untuk lebih banyak tawaran & pengalaman"
      },
      packages: {
        sub_title: {
          us: 'Tidak termasuk Guam, Saipan',
          it: 'Termasuk Vatican City, San Marino',
          va: 'Termasuk Itali, San Marino',
          sm: 'Termasuk Itali, Vatican City',
          ma: 'Termasuk Sahara Barat',
          eh: 'Termasuk Maghribi',
          ch: 'Termasuk liechtenstein',
          li: 'Termasuk Switzerland',
          fr: 'Termasuk Monaco',
          mc: 'Termasuk Perancis',
          fi: 'Termasuk Kepulauan Aland',
          ax: 'Termasuk Finland',
          gu: 'Termasuk Kepulauan Mariana Utara',
          mp: 'Termasuk guam'
        },
        unlimited_packages: 'Pakej data tanpa had',
        normal_packages: 'Pakej data biasa',
        multi_region_packages: 'Multi-rantau',
        regional_data: 'Data Rantauan',
        high_speed_text: 'data kelajuan tinggi',
        infiniteFlow:'Data tanpa had',
        unLimitData: 'Tanpa Had',
        high_speed_text_year: 'Kelajuan tinggi/MP',
        package_list: 'Senarai pakej',
        special_offer: 'Jualan',
        first_month: '1 Bulan',
        periodUnit: {
          day: 'hari (s)',
          month: 'bulan',
          hour: 'Jam',
          year: 'tahun',
        },
        periodUnits: {
          day: 'hari (s)',
          month: 'bulan',
          hour: 'Jam',
          year: 'tahun',
        },
        periodUnitSimp: {
          day: 'd',
          month: 'mo',
          hour: 'h',
          year: 'yr'
        },
        periodUnitMonthly:'Bulanan',
        periodUnitsSimp: {
          day: 'd',
          month: 'mo',
          hour: 'h',
          year: 'yr'
        },
        unlimited_good_name: {
          day: 'Pas hari',
          month: 'Pas bulanan',
          year: 'Lulus tahunan'
        },
        continuousMonth : "Bulan yang berterusan",
        continuousDay : "Hari yang berterusan",
        continuousYear:"Tahun yang berterusan",
        
        day_invalid: 'Tamat pada hari sekarang',
        month_invalid: 'Tamat pada bulan semasa',
        immediate_valid: 'Berkesan segera',
        tomorrow_day_valid: 'Berkuatkuasa dari hari berikutnya',
        tomorrow_month_valid: 'Berkuatkuasa dari bulan depan',
    
        // detail page
        detail: {
          cell_flow: 'Data',
          cell_period: 'Kesahihan',
          buy_quantity: 'Jumlah',
          use_area: 'Liputan',
          use_intro: 'Terma dan Syarat',
          buy_btn: 'Pesanan',
          pay: 'Bayar',
          buy_tips: 'Anda mempunyai pakej %@packageName sedang digunakan. Ingin membeli pakej ini?',
          haveOrderTips: "Pesanan menunggu pembayaran dijana. Klik Sah untuk pergi ke Halaman Data Saya！"
        },
    
        // confirm page
        confirm: {
          title: 'Pengesahan pesanan',
          real_pay_amount: 'Jumlah yang dibayar',
          online_payment: 'Pembayaran dalam talian',
          create_order_error: 'Persediaan gagal'
        }
      },
      pay: {
        // result page
        result: {
          loading_order_status: 'Mendapatkan Status Pesanan ...',
          buy_success: 'Pesanan lengkap',
          buy_pending: 'Pengesahan yang belum selesai',
          buy_pending_tip: 'Pembayaran dalam proses ... Jika pembayaran tidak dipindahkan dalam masa 10 minit, sila hubungi kami untuk sokongan.',
          get_payment_info_fail: 'Pengambilalihan maklumat pembayaran gagal',
          cell_package: 'Pakej',
          cell_buy_amount: 'Subtotal',
          cell_real_amount: 'Jumlah yang dibayar',
          go_to_order_btn: 'Pergi ke pakej saya',
          back_home: 'Kembali ke rumah',
          back_mall: 'Kembali ke pusat membeli -belah',
          ordersn_empty: 'Pesan SN tidak boleh kosong',
          order_search_error: 'Kesalahan yang tidak dijangka',
          goodsName: 'Nama produk'
        },
    
        //fail page
        fail: {
          payment_fail: 'Pembayaran gagal',
          back_home: 'Kembali ke rumah'
        }
      },
      CountryGroup: {
        title: "Negara/wilayah",
        placeholder: "Cari Negara atau Wilayah",
        clear: "Jelas",
        history: "Sejarah carian"
      },
      PromotionCode: {
        verification: {
          title: 'Kod baucar',
          minititle:'Kod baucar',
          input: 'Sila masukkan kod teratas',
          explain: 'Petua: Sentuh butang imbasan di bahagian atas kanan untuk mengimbas kod QR kad baucar, atau masukkan secara manual kod baucar (sensitif kes) jika tidak berfungsi.',
          submit: 'Hantar',
          exchange: 'Menebus',
          cancel: 'Batalkan',
          Inquiry: "Adakah anda pasti bertukar",
          ErrorCode: 'Ralat Kod Recharge',
        },
        recharge_success: {
          package: 'Pakej',
          content: 'Berjaya ditebus',
          back: 'Kembali ke pusat membeli -belah',
          view_packets: 'Pergi ke pakej saya'
        }
      },
      order: {
        state: {
          inUse: 'Diaktifkan',
          isFirst: 'Diprioritaskan',
          toFirst: 'Tetapkan keutamaan',
          inactive: 'Tidak aktif' // 无对应翻译，保留中文
        },
        periodUnits: {
          minute: 'minit (s)',
          hour: 'Jam',
          day: 'hari (s)',
          month: 'Bulan (s)',
        },
        useIntro: {
          tip1: 'Pakej data tanpa had mempunyai keutamaan yang lebih tinggi daripada pakej data kelantangan.',
          tip2: 'Keutamaan penggunaan akan berdasarkan tarikh pembelian untuk jenis pakej yang sama, iaitu, pakej dengan tarikh pembelian terawal akan digunakan terlebih dahulu, sementara keutamaan pakej rantau tunggal lebih tinggi daripada pakej serantau.',
          tip3: 'Anda juga boleh menyesuaikan keutamaan secara manual menggunakan paket jenis yang sama.'
        },
        myFlow: 'Data saya',
        remainingFlow: 'Data kiri',
        remainingTime: 'Kiri yang sah',
        remainingHighFlow: 'Data kelajuan tinggi ditinggalkan',
        validPeriod: 'Kesahihan',
        noneFlow: 'Tiada pakej data',
        noneFlowTip: 'Sila beli pakej data dan nikmati rangkaian berkualiti tinggi',
        buyPackFlow: 'Beli pakej',
        checkInvalidFlow: 'Periksa pakej data yang tamat tempoh',
        orderList: {
          "title": "pesanan saya",
          "amount_paid": "Jumlah",
          "device": "Peranti milik",
          "order_details": "Perincian pesanan",
          "total_amont": "Subtotal",
          "orderSN": "Pesan Tidak.",
          "createTime": "Masa penciptaan",
          "cancelTime": "Masa tertutup",
          "payTime": "Masa pesanan",
          "unsubTime": "Masa yang dibatalkan",
          "payMethod": "Kaedah pembayaran",
          "thirdSN": "Transaksi no.",
          "delete": "Padam",
          "cancel": "Batalkan pesanan",
          "unsub": "Bayaran balik",
          "goto_cancel": "Adakah anda mahu membatalkan pesanan?",
          "goto_unsubscribe": "Adakah anda ingin berhenti melanggan pesanan?",
          "delete_Tips": "Perintah itu tidak boleh disambung semula selepas dipadam, oleh itu masalah selepas perkhidmatan anda tidak dapat dikendalikan.Adakah anda pasti memadamkannya?",
          "status_success": "Selesai",
          "status_pending": "Tidak dibayar",
          "status_cancel": "Ditutup",
          "status_unsub": "Dibatalkan",
          "payMethod_stripe": "Kad Kredit"
        },
      },
      registerlogin: { 
        create_account_tip:"Buat akaun, mulakan pengalaman eksklusif",
        select_country_tip:"Peranti menggunakan negara/rantau",
        email_name: 'Mel',
        phone_name: 'Telefon',
        email_address: 'Alamat e -mel',
        password: 'kata laluan',
        country: 'negara',
        select_country: 'Pilih negara',
        cancel: 'Batalkan',
        confirm: 'Pasti',
        please_enter: 'Sila masukkan 6-20 aksara (gabungan huruf, nombor atau simbol)',
        select_country_tips: 'Pemilihan negara adalah untuk melihat pakej tempatan.Ia tidak boleh diubah selepas pendaftaran.Sila sahkan!',
        global_roaming: 'Kod Domain Antarabangsa',
        phone_number: 'nombor telefon',
        agree: 'bersetuju',
        user_agreement: 'Perjanjian Pengguna',
        and: 'dan',
        privacy_policy: 'Dasar Privasi',
        register_login: 'Daftar atau log masuk',
        login_error: "Bilangan log masuk terlalu kerap, sila cuba sebentar lagi!",
        register_error: "Bilangan pendaftaran terlalu kerap, sila cuba sebentar lagi!",
        forgot_pwd: 'Lupakan kata laluan',
        app_tips: 'Log masuk ke aplikasi dengan akaun ini selepas memuat turunnya untuk mengakses lebih banyak ciri.',
        download_app:'Pergi untuk memuat turun aplikasi',
        rememberPwd: 'Ingat kata laluan',
        third_login: "Teruskan dengan",
        agreement_tips: "Sila periksa kotak dasar Perjanjian dan Privasi Pengguna",
        selectCountry_tips: "Sila ambil perhatian bahawa negara berdaftar akan secara langsung mempengaruhi kaedah pembayaran dan mata wang berikut, sila pilih mengikut keperluan anda.",
        login_error_cancel: "Pengguna membatalkan log masuk",
        login_error_auth: "Sila benarkan pop-up dari tetapan pelayar",
        device_tips: "Peranti menunggu pengaktifan. Diproses dalam 24 jam."
      },
      forgotPwd: {
        forgot_pwd: 'Lupakan kata laluan',
        email_address: 'Alamat e -mel',
        next: 'Seterusnya',
        email_has_been_sent: 'Kami telah menghantar e -mel kepada %@email.Sila klik pada pautan dan ikuti langkah -langkah untuk mendapatkan kata laluan anda.',
        have_retrieved_it: 'Saya telah menjumpainya',
        unable_to_receive_email: 'Tidak dapat menerima e -mel?Sila periksa sama ada terdapat e -mel dari %@email di bawah direktori mel spam dan dipadam anda',
        or: 'atau',
        resend: 'Hantar semula',
        global_roaming: 'Kod Domain Antarabangsa',
        phone_number: 'nombor telefon',
        verification_code_has_been_sent: 'Kami telah menghantar kod pengesahan ke:',
        verification_code: 'Kod pengesahan',
        no_verification_code_received: 'Tidak menerima kod pengesahan?',
        please_enter: 'Sila masukkan 6-20 aksara (gabungan huruf, nombor atau simbol)',
        reset_password: 'Tetapkan semula kata laluan',
        reset_successful: 'Tetapkan semula berjaya',
      },
      coupons: {
        coupons_name: 'Kupon',
        no_coupons: 'Belum ada kupon',
        no_data: 'Belum ada data',
        applicable_to_the_following:'Kupon sesuai untuk pakej data berikut'
      },
      digital: {
        title: "Peranti SN",
        purchased: "Pembelian saya",
        viewAll: "Lebih",
        skinStore: "Kedai produk",
        completed: "Dibeli",
        goBuy: "Beli",
        order: {
            title: "Pesanan yang dibeli"
        },
        detail: {
            describe: "Penerangan"
        }
      },
      viewPL: {
        other: 'lain'
      },
      invalidFlow: {
        stateName: 'Status',
        state: {
          NOT_ACTIVATED: "Tidak aktif",
          IN_USING: "Terdapat",
          USE_END: "Letih",
          EXPIRE: "Tamat tempoh",
          TRANSFER: "Pemindahan",
          UNSUBSCRIBE: "Batalkan",
          VALID: "Sah",
          INVALID: "Tidak sah",
          EXCHANGE_POINTS: "Menebus mata"
        },
        noneFlow: 'Tiada pakej data yang tamat tempoh',
        pageName: 'Pakej data yang telah tamat tempoh'
      },
      flowDetail: {
        title: 'Butiran data',
        flow: 'Data',
        validTime: 'Permulaan yang sah',
        invalidTime: 'Sah sehingga',
        coverage: 'Liputan',
        useIntro: 'Terma dan Syarat',
        purchaseTime: 'Dibeli di',
        subtotal: 'Subtotal',
        status: 'Status',
        cancel: 'Batalkan',
        buyAgain: 'Beli lagi',
        validity: 'Kesahihan',
        tip: 'Notis',
        cancelTip: 'Adakah anda pasti ingin mengembalikan pakej ini?',
        dataLeft: 'Data kiri'
      },
      netError: {
        try_again: 'Cuba lagi',
        net_error: 'Tiada rangkaian',
        try_again_desc: 'Sila periksa tetapan rangkaian dan cuba lagi'
      },
      loadFail: {
        try_again: 'Cuba lagi',
        load_fail: 'Memuatkan gagal',
        load_fail_desc: 'Memuatkan data gagal, sila cuba lagi',
        IMEI_Not_Exist: 'IMEI tidak wujud, sila masuk dari pintu masuk yang betul',
        Project_Not_Exist:'Ralat berlaku.Sila hubungi Perkhidmatan Pelanggan. (01)',
        commonError:'Ralat berlaku.Sila hubungi Perkhidmatan Pelanggan.',
      },
      settlement_Easy_and_convenient:"Mudah dan mudah",
      settlement_Great_deal:"Banyak",
      settlement_Safe_and_secure:"Selamat dan selamat",
      settlement_Autopay_service_regulation:"Peraturan Perkhidmatan AutoPay",
      settlement_Read:"Baca",
      settlement_No_coupon:"Tiada kupon yang tersedia",
      settlement_Subtotal:"Subtotal",
      settlement_Coupon:"Kupon",
      settlement_TOTAL:"Jumlah",
      settlement_promotion_tip:"Tawaran promosi tidak boleh digunakan bersama dengan mana -mana kupon",
      settlement_coupon_tip:"Kupon tidak boleh digunakan bersama dengan tawaran promosi lain",
      member_myFlow_noList:"Tiada data",
      detail_se_content:"Cara yang selamat, mudah dan mudah.Anda boleh berhenti berlangganan pada bila -bila masa",
      Enter_Promo_code:"Kod promosi",
      Enter_Promo_Coupon:"Kupon",
      settlement_Not_used_coupon:"Kupon tidak digunakan",
      settlement_Available_coupon:"Terdapat",
      settlement_Unavailable_coupon:"Tidak tersedia",
      please_Enter_Promo_code:"Sila masukkan kod promosi",
      please_Select_Coupon_use:"Sila pilih kupon yang ingin anda gunakan.",
      Buy_Now:"Beli sekarang",
      Dont_Use_Any:"Jangan gunakan apa -apa",
      settlement_confirm:"Mengesahkan",
      settlement_tips:"Mengesahkan",
      flowDetail_unsubscribe: "Berhenti berlangganan",
      flowDetail_unsubscribed: "Berhenti berlangganan",
      flowDetail_isCancelPackage: "Hentikan langganan pakej ini?",
      flowDetail_confirmAgreementUnsubscribe : "Anda tidak boleh mempunyai banyak masalah selepas berhenti berlangganan.Adakah anda pasti mahu berhenti berlangganan?",
      flowDetail_cancel: "Batalkan",
      flowDetail_cancelSuccess: "Berhenti berlangganan dengan jayanya",
      packages_detail_promotion:"Promosi",
      orderTips:{
        "iDay" : "hari",
        "iDays" : "hari",
        "iMonth" : "bulan",
        "iMonths" : "bulan",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Pada pembelian pertama anda, Bayar %@money/%@periodSymbol kemudian, Anda boleh berhenti berlangganan pada bila -bila masa",
        'Monthly_discount':"Simpan %@saveMoney setiap %@period! Anda boleh berhenti berlangganan pada bila -bila masa",
        'Ordinary_monthly_package':"Cara yang selamat, mudah dan mudah.Anda boleh berhenti berlangganan pada bila -bila masa",
        "AlreadyPurchased":'Maaf bahawa anda hanya boleh melanggan satu pakej data pada masa ini.Sila berhenti berlangganan dari “%@” dan langgan kemudian ke mana -mana pakej yang anda inginkan selepas ia tamat.',
        "Contract_recommendation_First":'<label>Dengan perkhidmatan autopay, pada pembelian pertama anda, bayar sahaja</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Anda boleh berhenti berlangganan pada bila -bila masa'
        +'<a class="btn">Melanggan ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Dengan perkhidmatan autopay, bayar sahaja</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Anda boleh berhenti berlangganan pada bila -bila masa'
        +'<a class="btn">Melanggan ></a></p>',
        "Contract_recommendation_General":"<label>Dengan perkhidmatan autopay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Cara yang selamat, mudah dan mudah.Anda boleh berhenti berlangganan pada bila -bila masa'
        +'<a href="javascript:;" class="btn">Melanggan ></a></p>',
        'BanlanceDoubleCheck':'Adakah anda pasti mahu membayar dengan baki?',
    },
    feedback: {
      title: "maklum balas",
      placeholder: "Sila masukkan negara yang ingin anda lawati atau sebarang soalan lain, dan kami akan memenuhi keperluan anda secepat mungkin!",
      submit: "Hantar",
      submit_success: "Berjaya dihantar",
      other_opinions: "Opini lain",
    },
    view_country_input: 'Sila masukkan akaun anda',
    select_package: {
      title: "Pilih Data",
      allPackage: 'Semua Data',
      type: "Jenis",
      flow: "Data",
      month_package: "Pelan Bulanan",
      flow_package: "Paket Data",
      time: "Tempoh",
      period: "Kitaran",
      auto_debit: "Info Debit Automatik",
      auto_subscribe: "Auto-bahar",
      detail: "Butiran Data",
      carrier: "Operator yang Disokong",
      country: "Senarai Negara Diliputi",
      notice: "Panduan Pembelian"
    }
}